import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock, Collapse, Alert, Checkbox, Radio, Tooltip, OverlayTrigger, Glyphicon, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { setSubState, needsApproval, getLeaderName } from './Utility';
import moment from 'moment';
import PlacesAutocomplete, { geocodeByPlaceId } from 'react-places-autocomplete';


export class CCOButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }

  mouseOver() {
    this.setState({hover: true});
  }

  mouseOut() {
    this.setState({hover: false});
  }

  render() {

    var backColor = "#0076FF";
    var color = "#0076FF";

    switch(this.props.type) {
      case "white": color = "white"; backColor = '#650000'; break;
      case "primary": color = backColor = "#0076FF"; break;
      case "destructive": color = backColor = "red"; break;
    }

    var textColor = (this.state.hover || this.props.selected) ? 'white' : color;


    var style = {
      borderWidth: 2,
      borderColor: color,
      opacity: this.props.selected === false ? 0.8 : 1,
      color: textColor,
      width: this.props.width || '100%',
      maxWidth: this.props.maxWidth || null,
      height: 40,
      backgroundColor: (this.state.hover || this.props.selected) ? backColor : 'transparent',
      borderStyle: 'solid',
      cursor: 'pointer',
      fontSize: 14,
      fontFamily: "Lato, Open Sans, Helvetica",
      transition: '0.2s'
    };

    if (this.props.style) {
      Object.assign(style, this.props.style);
    }

    return (
      <button style={style} onMouseOver={this.mouseOver.bind(this)} onMouseOut={this.mouseOut.bind(this)} onClick={this.props.onClick}>
        {this.props.text}
      </button>
    );
  }
}

export class CCOButtonGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    };
  }

  onClick(number) {
    this.setState({selected: number});
    this.props.onClick(number);
  }

  render() {
    var items = this.props.items;
    var width = this.props.width / items.length;

    var style = {
      display: 'inline-block',
      marginLeft: -2
    }

    var buttons = items.map(function(item, i) {
      return <CCOButton style={style} type="primary" onClick={this.onClick.bind(this, i)} text={item} selected={this.state.selected === i} key={i} width={width} />;
    }.bind(this));

    return (<div>
      {buttons}
    </div>);
  }

}

export class CCOAlert extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }

  mouseOver() {
    this.setState({hover: true});
  }

  mouseOut() {
    this.setState({hover: false});
  }

  render() {

    return (
      <Collapse in={this.props.in}><div>
        <Alert bsStyle={this.props.type}>
          <h4>{this.props.title}</h4>
          <p>{this.props.content}</p>
        </Alert>
        <div style={{height:10}} />
      </div></Collapse>
    );

  }
}

export function LocationPicker({context, showLabel, comp}) {
  return (
    <FormGroup>
      <div style={{height: 8}} />
      {showLabel && <ControlLabel>Location</ControlLabel>}
      <div>
        <Radio checked={context.state[comp].atCCO} style={{float: 'left', width: 110}} onChange={() => {
          setSubState(context, comp, 'atCCO', true);
          setSubState(context, comp, 'location', 'f');
        }}>At CCO in the </Radio>
        <FormControl componentClass="select" style={{float: 'left', width: 200, marginTop: -7, marginLeft: 7}} onChange={e => {
          setSubState(context, comp, 'atCCO', true);
          setSubState(context, comp, 'location', e.target.value);
        }} value={context.state[comp].location}>
          <option value="f">Fellowship Hall</option>
          <option value="s">Sancturary</option>
          <option value="h">High School Room (Room 20)</option>
          <option value="m">Junior High Room (Room 21)</option>
          <option value="k">Game Room (Room 4)</option>
          <option value="c">Entire Church</option>
          <option value="l">Conference Room</option>
        </FormControl>
      </div>

      <br></br>
      <div style={{height: 25}} />

      <div>
        <Radio checked={!context.state[comp].atCCO} style={{float: 'left', width: 130}} onChange={() => {
          setSubState(context, comp, 'atCCO', false);
          setSubState(context, comp, 'location', '');
        }}>Other Location: </Radio>
        <PlacesAutocomplete
          onSelect={(address, placeId) => {
            setSubState(context, comp, 'location', address);
            setSubState(context, comp, 'placeId', placeId);
            geocodeByPlaceId(placeId).then(results => {
              setSubState(context, comp, 'directionsAvailable', true);
              setSubState(context, comp, 'address', results[0].formatted_address);
            }).catch(err => console.log(err));
          }}
          value={context.state[comp].atCCO ? '' : context.state[comp].location}
          onChange={address => {setSubState(context, comp, 'location', address); setSubState(context, comp, 'directionsAvailable', false); setSubState(context, comp, 'atCCO', false)}}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div style={{
              float: 'left',
              width: 250,
              marginTop: -7
            }}>
              <input
                {...getInputProps({
                  disabled: context.state[comp].atCCO,
                  type: "text",
                  placeholder: "Search Places",
                  name: 'Places-input',
                  id: "places-input",
                  className: 'form-control',
                })}
              />
              <div className="autocomplete-dropdown-container" style={{ zIndex: 500 }}>
                {loading && <div>Loading...</div>}
                {suggestions.map(suggestion => {
                  const style = suggestion.active
                    ? { backgroundColor: '#fafafa' }
                    : { backgroundColor: '#ffffff' };
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className: 'suggestion-item',
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </div>

      <div style={{height: 25}} />
      <br />
    </FormGroup>
  )
}

export function FieldGroup({ id, label, help, bottomElement, ...props }) {
  return (
    <FormGroup controlId={id}>
      {label && <ControlLabel color="black">{label}</ControlLabel>}
      <Input id={id} {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
      {bottomElement}
    </FormGroup>
  );
}

function Input({ id, context, comp, ...props }) {
  return (
    <FormControl type="text" onChange={function(e) {
      var obj = context.state[comp];
      obj[id] = e.target.value
      var obj2 = {};
      obj2[comp] = obj;
      context.setState(obj2);
    }} value={context.state[comp][id]} {...props} />
  );
}

export function TimePicker({ comp, context }) {
  return (
    <FormGroup controlId="time">
      <div className="setupColumn">
        <ControlLabel>Start Time</ControlLabel><br />
        <div style={{marginLeft: -60}}><Datetime timeConstraints={{minutes: {step: 15}}} open={true} dateFormat={false} value={moment.unix(context.state[comp].date)} input={false} onChange={function(e) {
          var obj = context.state[comp];
          obj.date = e.unix();
          if (obj.date >= obj.endDate && moment.unix(obj.date).date() === e.add(1, 'hours').date()) {
            obj.endDate = e.unix();
          }
          var newObj = {};
          newObj[comp] = obj;
          context.setState(newObj);
        }} /></div>
      </div>
      <div className="setupColumn">
        <ControlLabel>End Time</ControlLabel><br />
        <div style={{marginLeft: -60}}><Datetime timeConstraints={{minutes: {step: 15}}} open={true} dateFormat={false} value={moment.unix(context.state[comp].endDate)} input={false} onChange={function(e) {
          var obj = context.state[comp];
          obj.endDate = e.unix();
          if (obj.date >= obj.endDate && moment.unix(obj.date).date() === e.subtract(1, 'hours').date()) {
            obj.date = e.unix();
          }
          var newObj = {};
          newObj[comp] = obj;
          context.setState(newObj);
        }} /></div>
      </div>
    </FormGroup>
  );
}

export function Select({ id, label, children, comp, context, onChange, bottomElement, ...props }) {
  return (
    <FormGroup controlId={id}>
      {label !== undefined && <ControlLabel>{label}</ControlLabel>}
      <FormControl componentClass="select" {...props} onChange={function(e) {
        if (onChange) {
          onChange(e.target.value);
        }

        if (comp) {
          let obj = context.state[comp];
          obj[id] = e.target.value;
          let obj2 = {};
          obj2[comp] = obj;
          context.setState(obj2);
        } else {
          let obj = {};
          obj[id] = e.target.value;
          context.setState(obj);
        }

      }} value={comp ? context.state[comp][id] : context.state[id]}>
        {children}
      </FormControl>
      {bottomElement}
    </FormGroup>
  );
}

export function Option({ id, label, comp, text, context }) {
  if (label) {
    return (
      <FormGroup controlId={id}>
        <ControlLabel>{label}</ControlLabel>
        <Checkbox checked={context.state[comp][id]} onChange={function() {
          var obj = context.state[comp];
          obj[id] = !obj[id];
          var obj2 = {};
          obj2[comp] = obj;
          context.setState(obj2);
        }}>{text}</Checkbox>
      </FormGroup>
    );
  } else {
    return (
      <Checkbox checked={context.state[comp][id]} onChange={function() {
        var obj = context.state[comp];
        obj[id] = !obj[id];
        var obj2 = {};
        obj2[comp] = obj;
        context.setState(obj2);
      }}>{text}</Checkbox>
    );
  }

}

export function SectionHeader({ title }) {
  return (
    <div style={{marginTop: 30, marginBottom: 20, maxWidth: 500}}>
      <p style={{color: 'grey',
        backgroundColor: 'white',
        display: 'inline-block',
        borderLeft: '10px solid white',
        borderRight: '10px solid white'}}>{title}</p>
      <div style={{backgroundColor: 'grey',
        height: 1,
        width: '100%',
        marginTop: -20}} />
    </div>
  );
}

export function InfoView({ title, text }) {
  return (
    <div style={{position: 'absolute', top: '50%', left: '50%', marginLeft: -300, width: 600}}>
      <center>
        <p style={{color: 'gray', fontSize: '16pt', textAlign: 'center'}}>{title}</p>
        <p style={{color: 'gray', textAlign: 'center'}}>{text}</p>
      </center>
    </div>
  )
}

function validateURL(str) {
  return  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( str );
}

export class CustomButtomView extends Component {

  constructor(props) {
    super(props)

    this.state = {
      newButtonLink: "",
      newButtonTitle: "",
      invalidLink: false
    }
  }

  getCurrentEntry() {
    return {title: this.state.newButtonTitle, link: this.state.newButtonLink};
  }

  addNewButton() {
    if (this.state.newButtonTitle !== "" && this.state.newButtonLink !== "") {
      if (!validateURL(this.state.newButtonLink)) {
        this.setState({invalidLink: true});
      } else {
        this.props.addButton({title: this.state.newButtonTitle, link: this.state.newButtonLink});
        this.setState({newButtonLink: "", newButtonTitle: "", invalidLink: false});
      }
    }
  }

  render() {

    const buttonsTooltip = (
      <Tooltip id="tooltip">These button will appear on the event page in the app, and allow you to direct users to external sites such as Facebook Events, Sign Up Genius, Registration Pages, etc.</Tooltip>
    );

    return (
      <FormGroup>
        <ControlLabel color="black">Custom Buttons  <OverlayTrigger placement="right" overlay={buttonsTooltip}><Glyphicon glyph="info-sign" /></OverlayTrigger></ControlLabel>
        <table className="rsvpTable">
          <tbody>
            {this.props.buttons && this.props.buttons.map((item, i) => {
              return (
                <tr key={i}>
                  <td style={{paddingLeft: 20}}><p>{item.title}</p></td>
                  <td style={{paddingLeft: 20}}><a href={item.link} target="_blank">{item.link}</a></td>
                  <td><Button bsStyle="danger" onClick={this.props.removeButton.bind(this, i)}><Glyphicon glyph="trash" /></Button></td>
                </tr>
              )
            })}
            <tr>
              <td><FormControl type="text" onChange={e => this.setState({newButtonTitle: e.target.value})} value={this.state.newButtonTitle} placeholder="Title" /></td>
              <td><FormControl type="text" onChange={e => this.setState({newButtonLink: e.target.value})} value={this.state.newButtonLink} placeholder="Link (Full URL)"/></td>
              <td><Button bsStyle="primary" onClick={this.addNewButton.bind(this)}><Glyphicon glyph="ok" /></Button></td>
            </tr>
          </tbody>
        </table>
        <div style={{height: 8}} />
        <CCOAlert in={this.state.invalidLink} type="warning" title="Invalid Link" content="Please make sure the link is the full URL, including the http:// at the beginning" />
      </FormGroup>
    )
  }
}

export class EventApprovalSection extends Component {

  undoPressed(level) {
    window.base.post("events/" + this.props.event.key + "/" + level, {data: false})
    switch (level) {
      case 'approval1':
        window.show('success', "Sent back to Availability Approval", "The previous approval was revoked, make sure to let them know why!");
        break;
      case 'approval3':
        window.show('success', "Sent back to Technical Approval", "The previous approval was revoked, make sure to let them know why!");
        break;
    }
  }

  render() {
    let approvalsNeeded = needsApproval(this.props.event);

    let approvals = {
      approval1: ["Availability Approval", "Availability"],
      approval2: ["Validity Approval", "Validity"],
      approval3: ["Technical Approval", "Technical Setup"],
      approval4: ["Final Approval", "Publishing"]
    }

    return (
      <div>
        {Object.keys(approvals).map(key => {
          if (this.props.event[key]) return <p key={key}><Glyphicon glyph="ok" /> Approved By {getLeaderName(this.props.event[key])} for {approvals[key][1]} {this.props.undo && (this.props.undo[key] || this.props.undo.approval4) && <button className="blueButton" onClick={this.undoPressed.bind(this, key)}>Undo</button>}</p>;
          else if (approvalsNeeded && approvalsNeeded.indexOf(key) !== -1) return <p key={key}><Glyphicon glyph="time" /> Waiting on {approvals[key][0]}</p>;
          else return null;
        })}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/util/Components.js
 **/